import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import DataTable from "react-data-table-component";
import { Form } from "react-bootstrap";
import {
  BidAllData,
  BidWinnerListData,
  PlayerGetRequestableManagers,
} from "../../redux/auth-reducer/auth-service";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import { ResultsPager } from "../../CommonComponent/Results/ResultsPager";
import { useSearchedPagedList } from "../../hooks/useSearchedPagedList";
import { bidTimeLabel } from "../../utils/helper/auctionForm";

const columns = [
  {
    name: "#",
    selector: (row, index) => index + 1,
    sortable: true,
    width: "80px",
  },
  {
    name: "Auction Name",
    selector: (row) => row?.auctionName,
    sortable: true,
  },
  {
    name: "Team Name",
    selector: (row) => row?.teamName,
    sortable: true,
    width: "250px",
  },

  {
    name: "Bid Time Limit",
    selector: (row) => row?.bidTime,
    format: (row) => bidTimeLabel(row?.bidTime),
    sortable: true,
  },
  {
    name: "Starting Bid",
    selector: (row) => row?.startingBid,
    sortable: true,
  },
  {
    name: "Bid Increment",
    selector: (row) => row?.bidIncrement,
    sortable: true,
  },
  {
    name: "Current Bid",
    selector: (row) => row?.currentBidAmount,
    sortable: true,
  },
  {
    name: "Auction Created By",
    selector: (row) => row?.createdByName,
    sortable: true,
  },
  {
    name: "Total Bids",
    selector: (row) => row?.totalPlacedBids,
    sortable: true,
  },
];

const columns2 = [
  {
    name: "#",
    selector: (row, index) => index + 1,
    sortable: true,
    width: "80px",
  },
  {
    name: "Auction Name",
    selector: (row) => row?.auctionName,
    sortable: true,
  },
  {
    name: "Team Name",
    selector: (row) => row?.teamName,
    sortable: true,
  },
  {
    name: "Bid Amount",
    selector: (row) => row?.bidAmount,
    sortable: true,
  },

  {
    name: "Bid Status",
    selector: (row) => row?.status,
    sortable: true,
  },
];

/** The search box above a tab's table; the clear button empties it and reloads at once. */
const SearchBox = ({ pager }) => (
  <>
    <input
      type="text"
      className="form-control mb-3 mt-3"
      placeholder="Search..."
      value={pager.searchText}
      onChange={(e) => pager.setSearchText(e.target.value)}
    />
    {pager.searchText && (
      <button className="btn btn-clear" onClick={pager.clearSearch}>
        <span>&times;</span> {/* This represents the close icon */}
      </button>
    )}
  </>
);

const Pager = ({ pager }) => (
  <ResultsPager
    page={pager.page}
    totalPages={pager.totalPages}
    perPage={pager.perPage}
    pageSizes={pager.pageSizes}
    onPerPageChange={pager.changePerPage}
    onPrevious={pager.previousPage}
    onNext={pager.nextPage}
  />
);

/**
 * The ALL tab: every bid the player placed (Bid/GetAll).
 *
 * #184 (reopened): the search is the server's - usp_GetAllBidData matches the auction, team and
 * Manager names and counts the matches for the pager. It used to filter only the rows of the page
 * already loaded, so a bid on any other page was never found.
 */
const AllBidsTab = () => {
  const pager = useSearchedPagedList(BidAllData);
  const [allManager, setAllManager] = useState([]);
  const [selectedManagerId, setSelectedManagerId] = useState("");

  useEffect(() => {
    PlayerGetRequestableManagers().then((res) => {
      setAllManager(res?.data?.data?.dataList);
    });
  }, []);

  // The Manager filter has no server parameter, so it still narrows the page shown. Its "Select"
  // option has an empty value: without one it read "Select", and picking it again after a Manager
  // matched no row at all.
  const rows = selectedManagerId
    ? pager.rows.filter((item) => item?.createdBy === parseInt(selectedManagerId, 10))
    : pager.rows;

  return (
    <div>
      <div className="search-input bid-search filter d-flex align-items-center stickey-parent-div">
        <label className="sort-status">Filter By</label>

        <Form.Select
          name="gender"
          className="me-4"
          required
          as="select"
          value={selectedManagerId}
          onChange={(e) => setSelectedManagerId(e.target.value)}
        >
          <option value="">Select</option>
          {allManager?.map((manager) => (
            <option key={manager?.managerId} value={manager?.managerId}>
              {manager?.firstName} {manager?.lastName}
            </option>
          ))}
        </Form.Select>

        <SearchBox pager={pager} />
      </div>

      <div>
        <DataTable title="Bid List" columns={columns} data={rows} />
        <Pager pager={pager} />
      </div>
    </div>
  );
};

/**
 * The Winner tab: the lots the player leads or has won (Bid/GetMyBidWinings). Searched on the
 * server like the ALL tab (usp_GetBidWinDetailsById).
 */
const WinnerTab = () => {
  const pager = useSearchedPagedList(BidWinnerListData);

  return (
    <>
      <div className="search-input filter d-flex align-items-center">
        <SearchBox pager={pager} />
      </div>

      <div>
        <DataTable title="Bid List" columns={columns2} data={pager.rows} />
        <Pager pager={pager} />
      </div>
    </>
  );
};

export const Bid = () => {
  const [data, setData] = useState(false);
  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabWinner") || "BidAlll";
  });

  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("activeTabWinner", key);
  }, [key]);

  // The dashboard's "see all" links open a given tab.
  useEffect(() => {
    if (location.state && location.state.targetTab) {
      setKey(location.state.targetTab);
    }
  }, [location.state]);

  const sidebarfun = () => {
    setData(!data);
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Bid History</h1>

          <div className="group_data_table">
            <div className="group_data_table tabs-auction bidAllData ">
              <div className="tabs-box">
                {/* Each tab owns its list, paging and search, and loads when first opened. They
                    used to share one page number and page count, and every tab switch or page
                    change fetched twice. */}
                <Tabs
                  id="auctiontabs"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-0 tab-list-item"
                  justify
                  mountOnEnter
                >
                  <Tab eventKey="BidAlll" className="mt-3" title="ALL">
                    <AllBidsTab />
                  </Tab>
                  <Tab eventKey="Winner" className="mt-3" title="Winner">
                    <WinnerTab />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
